export const FETCH_USER_YEAR = 'FETCH_USER_YEAR'
export const FETCH_USER_YEAR_LOADING = 'FETCH_USER_YEAR_LOADING'
export const FETCH_USER_YEAR_ERROR = 'FETCH_USER_YEAR_ERROR'
export const FETCH_USER_YEAR_SUCCESS = 'FETCH_USER_YEAR_SUCCESS'

export const ACTIVATE_STAT_CARD = 'ACTIVATE_STAT_CARD'

export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV'
export const TOGGLE_COMMUNITY_STATS = 'TOGGLE_COMMUNITY_STATS'

export const SHARE_ON_FACEBOOK = 'SHARE_ON_FACEBOOK'
export const SHARE_ON_FACEBOOK_LOADING = 'SHARE_ON_FACEBOOK_LOADING'
export const SHARE_ON_FACEBOOK_ERROR = 'SHARE_ON_FACEBOOK_ERROR'
export const SHARE_ON_FACEBOOK_SUCCESS = 'SHARE_ON_FACEBOOK_SUCCESS'



// WEBPACK FOOTER //
// ./src/services/yearInReview/constants.js